

























import * as Palette from '@/assets/palette'
import fleche from '@/assets/fleche'
import Vue from 'vue'

// import testWindData from '@/test/wind-data'
// import { SwipeDetector } from 'swipedetector'

export default {
  name: 'alti-winds-view',

  data() {
    return {
      canvas: undefined,
      ctx: undefined,
      scaleCanvas: undefined,
      scaleCtx: undefined,
      pxRatio: window.devicePixelRatio || 1,
      waitForRedraw: false,
      cache: {}
    }
  },
  props: [
    'redraw'
  ],
  computed: {
    date() {
      return String(this.$store.getters['time/date']).substring(0, 8)
    },
    run() {
      return this.$store.getters['time/run']
    },
    private() {
      return this.$store.getters['time/private'] && !this.$store.getters['auth/isContributor']
    },
    lat() {
      return this.$store.state.persistent.center.lat
    },
    lon() {
      return this.$store.state.persistent.center.lon
    },
    dataUrl() {
      if (this.run === undefined) return undefined
      if (this.private) return undefined
      return `https://data0.meteo-parapente.com/data2017.php?run=${this.run}&location=${this.lat},${this.lon}&date=${this.date}&plot=windgram`
    },
    data() {
      return this.dataUrl in this.cache ? this.cache[this.dataUrl] : undefined
    },
    loading() {
      return this.data === undefined && !this.private
    },
    colorblind() {
      return this.$store.state.persistent.colorblind
    },
    timezone() {
      return this.$store.state.persistent.timezone
    },
    topAltitude: {
      get() {
        return this.$store.state.persistent.windgramTopAltitude
      },
      set(val) {
        this.$store.dispatch('persistent/setWindgramTopAltitude', val)
      }
    },
    windUnit() {
      return this.$store.state.persistent.windUnit
    }
  },
  watch: {
    redraw() {
      this.delayedDraw()
    },
    colorblind() {
      this.delayedDraw()
    },
    timezone() {
      this.delayedDraw()
    },
    dataUrl() {
      this.loadData()
    },
    lat() {
      this.cache = {}
    },
    lon() {
      this.cache = {}
    },
    topAltitude() {
      this.delayedDraw()
    },
    windUnit() {
      this.delayedDraw()
    }
  },

  mounted() {
    this.canvas = this.$refs.canvas
    this.ctx = this.canvas.getContext('2d')
    this.scaleCanvas = this.$refs.scale
    this.scaleCtx = this.scaleCanvas.getContext('2d')
    window.addEventListener('resize', this.draw)
    this.$refs.scrollable.addEventListener('wheel', e => {
      if (e.deltY !== 0) {
        this.$refs.scrollable.scrollLeft += (e.deltaY * 30)
        e.preventDefault()
      }
    })
    /* const swipe = new SwipeDetector(this.$el).emitter
    swipe.on('left', () => {
      const scroll = this.$el.clientWidth + this.$el.scrollLeft - this.$el.scrollWidth
      if (scroll > 80) {
        this.$emit('swipe-tab', 1)
      }
    })
    swipe.on('right', () => {
      this.draw()
      if (this.$el.scrollLeft < -80) {
        this.$emit('swipe-tab', -1)
      }
    }) */
    this.loadData()
  },
  activated() {
    this.delayedDraw()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.delayedDraw)
  },
  methods: {
    delayedDraw() {
      if (this.waitForRedraw) return
      this.waitForRedraw = true
      requestAnimationFrame(() => {
        this.draw()
        this.waitForRedraw = false
      })
    },
    loadData() {
      const url = this.dataUrl
      if (this.data === undefined) {
        if (this.ctx !== undefined) this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
        this.$http.get(url).then(response => {
          if (response.body.status === 'ok') {
            Vue.set(this.cache, url, response.body.data)
            this.delayedDraw()
          } else if (response.body.error === 'out_of_bounds') {
            Vue.set(this.cache, url, 'no-data')
          }
        })
      } else {
        this.delayedDraw()
      }
    },
    draw() {
      /* eslint no-multi-assign: 0 */
      /* eslint no-mixed-operators: 0 */
      if (this.data === undefined || this.data === 'no-data') return
      const box = {
        top: 0,
        left: 0,
        h: 0,
        w: 0,
        bottom: 0
      }

      const c = this.ctx
      const w = this.canvas.width = this.canvas.clientWidth * this.pxRatio
      const h = this.canvas.height = this.canvas.clientHeight * this.pxRatio

      const sc = this.scaleCtx
      this.scaleCanvas.width = this.scaleCanvas.clientWidth * this.pxRatio
      this.scaleCanvas.height = this.scaleCanvas.clientHeight * this.pxRatio

      const colorblind = this.colorblind
      // const wind = 'kmh' // a renommer

      const scaleStep = 500

      const heureStop = 21
      const heureStart = 4
      const tz = 0
      const date = new Date(this.date.replace(/(\d{4})(\d{2})(\d{2})/, `$1-$2-$3T00:00:00Z`))

      const data = this.data // todo

      const nZ = data[String(`0${heureStart - tz}:00`).slice(-5)].z.length

      // clear
      c.clearRect(0, 0, w, h)
      sc.clearRect(0, 0, w, h)

      // taille
      const nh = (heureStop - heureStart) + 1
      box.top = 25 * this.pxRatio
      box.left = 0 // 40 * this.pxRatio
      box.bottom = 33 * this.pxRatio
      box.h = h - box.top - box.bottom
      const colw = (w - box.left) / nh
      box.w = colw * nh
      const kmOffset = box.h / this.topAltitude

      // Terrain
      const ter = kmOffset * data[String(`0${heureStart - tz}:00`).slice(-5)].ter

      c.beginPath()
      c.rect(box.left, box.top + box.h, box.w, -ter)
      c.fillStyle = '#ccc'
      c.fill()

      for (let icol = 0; icol < nh; icol++) {
        const heure = heureStart + icol - tz
        const left = box.left + (colw * icol)

        // couche convective
        const pblh = data[String(`0${heure}:00`).slice(-5)].pblh * kmOffset
        c.beginPath()
        c.rect(left, box.top + box.h - ter, colw, -pblh)
        c.fillStyle = '#ffff77'
        c.fill()

        // nuages new
        for (let iz = 0; iz < nZ; iz++) {
          const altiA = data[String(`0${heureStart - tz}:00`).slice(-5)].z[iz]
          const altiB = data[String(`0${heureStart - tz}:00`).slice(-5)].z[iz + 1]
          const hauteur = (altiA - altiB) * kmOffset
          if (altiA > this.topAltitude) break
          const altiBottom = box.top + box.h - (kmOffset * altiA)
          c.beginPath()
          c.rect(left, altiBottom, colw - 12 * this.pxRatio, hauteur)
          c.fillStyle = 'rgba(155, 155, 155, ' + data[String(`0${heure}:00`).slice(-5)].cldfra[iz] + ')'
          c.fill()
        }

        // nuages
        if (isNaN(data[String(`0${heure}:00`).slice(-5)].cfracl)) {
          c.beginPath()
          c.fillStyle = 'rgba(155, 0, 0, 0.5)'
          c.rect(left, box.top - 25 * this.pxRatio, colw, 15 * this.pxRatio)
          c.fill()
        } else {
          const rgbL = Math.round(255 - data[String(`0${heure}:00`).slice(-5)].cfracl)
          const rgbM = Math.round(255 - data[String(`0${heure}:00`).slice(-5)].cfracm)
          const rgbH = Math.round(255 - data[String(`0${heure}:00`).slice(-5)].cfrach)
          c.beginPath()
          c.fillStyle = 'rgb(' + rgbH + ', ' + rgbH + ', ' + rgbH + ')'
          c.rect(left, box.top - 25 * this.pxRatio, colw, 5 * this.pxRatio)
          c.fill()
          c.beginPath()
          c.fillStyle = 'rgb(' + rgbM + ', ' + rgbM + ', ' + rgbM + ')'
          c.rect(left, box.top - 20 * this.pxRatio, colw, 5 * this.pxRatio)
          c.fill()
          c.beginPath()
          c.fillStyle = 'rgb(' + rgbL + ', ' + rgbL + ', ' + rgbL + ')'
          c.rect(left, box.top - 15 * this.pxRatio, colw, 5 * this.pxRatio)
          c.fill()
        }
      }
      // lignes nuages
      c.strokeStyle = '#aaa'
      for (let i = 2; i < 6; i++) {
        const level = box.top - (i * 5 * this.pxRatio) + 0.5 * this.pxRatio
        c.beginPath()
        c.moveTo(box.left, level)
        c.lineTo(box.left + box.w, level)
        c.lineWidth = 0.5 * this.pxRatio
        c.stroke()
      }

      // colonnes
      c.strokeStyle = '#ddd'
      const max = nh + 1
      for (let icol = 0; icol < max; icol++) {
        const left = box.left + (colw * icol)
        // const milieu = left + (colw / 2)
        c.beginPath()
        c.moveTo(left, box.top)
        c.lineTo(left, box.h + box.top + box.bottom)
        c.lineWidth = 2 * this.pxRatio
        c.stroke()
      }

      // legende alti
      // const altiLeft = box.left - 5 * this.pxRatio
      const altiLeft = 35 * this.pxRatio

      sc.font = `${14 * this.pxRatio}px Arial`
      sc.fillStyle = 'black'
      sc.textAlign = 'right'

      for (let i = 0; i < this.topAltitude / scaleStep; i++) {
        const alti = scaleStep * i
        const altiTop = box.top + box.h - (kmOffset * alti)
        sc.fillText(alti, altiLeft, altiTop)
      }
      // sc.fillText('(m)', altiLeft, box.top + 10 * this.pxRatio)
      // c.fillText('(m)', altiLeft, box.top + 25)

      // vent
      c.fillStyle = 'black'
      let isPluie = false
      let palette = 'PAL_WIND'
      if (colorblind) palette += '_CB'
      for (let icol = 0; icol < nh; icol++) {
        let last = h
        const heure = heureStart + icol
        const heurez = heure - tz
        const left = box.left + (colw * icol)
        const milieu = left + (colw / 2)
        c.font = `${10 * this.pxRatio}px Arial`
        c.textAlign = 'left'
        for (let iz = 0; iz < nZ; iz++) {
          const alti = data[String(`0${heureStart - tz}:00`).slice(-5)].z[iz]
          if (alti > this.topAltitude) break
          const altiTop = box.top + box.h - (kmOffset * alti)
          if (last - altiTop < 10 * this.pxRatio) continue
          last = altiTop

          const u = data[String(`0${heurez}:00`).slice(-5)].umet[iz]
          const v = data[String(`0${heurez}:00`).slice(-5)].vmet[iz]
          const ms = Math.sqrt((u * u) + (v * v))
          const kmh = Math.round(ms * 3.6)
          /*
          switch (wind) {
            case 'ms':
              c.fillText(Math.round(ms), milieu + 4 * this.pxRatio, altiTop)
              break
            case 'nds':
              c.fillText(Math.round(ms * 1.94), milieu + 4 * this.pxRatio, altiTop)
              break
            default:
            case 'kmh':
              c.fillText(kmh, milieu + 4 * this.pxRatio, altiTop)
              break
          } */

          c.fillText(Math.round(this.$getwind(ms)), milieu + 4 * this.pxRatio, altiTop)

          const w = (4 / 30 * kmh) * this.pxRatio
          // if (w>7) w=7
          const rgb = Palette.getColor(ms, palette) // todo
          if (w > 0) {
            fleche({
              x: milieu - this.pxRatio,
              y: altiTop,
              a: Math.atan2(u, v) + Math.PI,
              s: 10 * this.pxRatio,
              w,
              color: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',1)'
            }, c, this.pxRatio)
          } else {
            c.beginPath()
            c.arc(milieu - 3 * this.pxRatio, altiTop - 4 * this.pxRatio, this.pxRatio, 0, 2 * Math.PI, true)
            c.fill()
          }
        }

        c.textAlign = 'center'

        if (data[String(`0${heurez}:00`).slice(-5)].raintot >= 0.009 || isNaN(data[String(`0${heurez}:00`).slice(-5)].raintot)) {
          c.font = `${12 * this.pxRatio}px Arial`
          let pluieTxt = ''
          if (isNaN(data[String(`0${heurez}:00`).slice(-5)].raintot)) {
            pluieTxt = '?'
            c.fillStyle = 'black'
          } else {
            pluieTxt = Math.round(data[String(`0${heurez}:00`).slice(-5)].raintot * 10) / 10
            c.fillStyle = 'navy'
          }
          c.fillText(pluieTxt, milieu, h - 21 * this.pxRatio)
          isPluie = true
        }

        c.font = `${14 * this.pxRatio}px Arial`
        c.fillStyle = 'black'

        const heureDate = new Date(date.valueOf() + heure * 3600 * 1000)
        const heuretxt = Vue.options.filters.moment(heureDate, 'H') + 'h'
        c.fillText(heuretxt, milieu, h - 5 * this.pxRatio)
      }

      // legende pluie
      if (isPluie) {
        c.font = `${12 * this.pxRatio}px Arial`
        c.fillStyle = 'navy'
        c.textAlign = 'right'
        c.fillText('pluie', box.left - 5 * this.pxRatio, h - 21 * this.pxRatio)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/alti-winds-view.vue